import { State } from 'modules';

export const getCurrentRoute = (state: State): string | null =>
  state.routing.location && state.routing.location.pathname;

export const isOnSearchRoute = (state: State): boolean =>
  getCurrentRoute(state) === '/search';



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/routes.ts